import { render, staticRenderFns } from "./MenuTreeItem.vue?vue&type=template&id=2ccfa0a2&scoped=true&"
import script from "./MenuTreeItem.vue?vue&type=script&lang=js&"
export * from "./MenuTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuTreeItem.vue?vue&type=style&index=0&id=2ccfa0a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfa0a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccfa0a2')) {
      api.createRecord('2ccfa0a2', component.options)
    } else {
      api.reload('2ccfa0a2', component.options)
    }
    module.hot.accept("./MenuTreeItem.vue?vue&type=template&id=2ccfa0a2&scoped=true&", function () {
      api.rerender('2ccfa0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuTree/MenuTreeItem.vue"
export default component.exports